module.exports = __webpack_public_path__ + "img/hover_icon_sie_replacement.906bd058.svg";